import { IconButton } from "@mui/material";
import { ReactNode, forwardRef } from "react";

interface MenuItemProps {
  onClick: any;
  icon: ReactNode;
}

const MenuItem = forwardRef<HTMLButtonElement, MenuItemProps>((props, ref) => {
  const { onClick, icon, ...rest } = props;

  return (
    <IconButton size="large" onClick={onClick} ref={ref} {...rest}>
      {icon}
    </IconButton>
  );
});

MenuItem.displayName = "MenuItem";

export default MenuItem;
